<template>

  <!-- Event Card -->
  <div
    class="event-card"
    @click="$emit('click')"
    :class="{'cursor-pointer': $listeners.click}">

    <div
      class="text-body2 q-mb-ss q-mx-sm row">

      <q-avatar
        size="16px"
        class="q-mr-xs"
        :style="{backgroundColor: typeColor}"/>

      <span>
        {{ typeTitle }}
      </span>

      <q-space/>

      <div>
        {{ dateTime }}
      </div>

    </div>

    <div
      class="event-card__media">

      <!-- Miniature -->
      <file-background
        :ratio="ratio"
        :value="value.miniature"
        class="event-card__miniature"/>


      <div
        class="event-card__actions">

        <img
          class="event-card__button_hover"
          src="/images/icons/fab-arrow-right.svg"/>

        <img
          class="event-card__button"
          src="/images/icons/fab-arrow-right-hover.svg"/>

      </div>

    </div>

    <div
      class="event-card__body q-ma-sm">

      <div
        v-html="value.title.ru"
        class="event-card__title"/>

    </div>

  </div>

</template>

<script>

  import FileBackground from '@src/components/file/file-background';

  export default {
    name: 'event-card',
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      ratio: {
        type: Number,
        default: 16 / 8,
      },
    },
    components: {
      FileBackground,
    },
    computed: {
      typeTitle() {

        const title = this.value &&
          this.value.eventType &&
          this.value.eventType.title ||
          'Событие';

        return this.$u.localize(title);
      },
      typeColor() {

        return this.value &&
          this.value.eventCategory &&
          this.value.eventCategory.color ||
          '#ccc';
      },
      dateTime() {

        return this.$date.humanDate({
          first: this.value.startDate,
          second: this.value.endDate,
          local: true,
        });
      },
    },
  };

</script>

<style lang="scss">

  $cls: event-card;

  .event-card {
    height: 100%;
    color: inherit;

    &:hover {

      .#{$cls}__miniature {
        box-shadow: $card-shadow;
      }

      .#{$cls}__button {
        opacity: 0;
      }

      .#{$cls}__button_hover {
        opacity: 1;
      }
    }

    &__title {
      font-weight: bold;
      font-size: 1.2rem;
      line-height: 1.5rem;
      margin-bottom: $spacer-sm;
    }

    &__media {
      line-height: 0;
      position: relative;
    }

    &__miniature {
      width: 100%;
      overflow: hidden;
      border-radius: $card-radius;
      transition: box-shadow .2s linear;
    }

    &__head {
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      position: absolute;
      justify-content: flex-end;
      margin: $spacer-sm $spacer-mm;
    }

    &__actions {
      @include abs-fill;
      margin: $spacer-sm $spacer-mm;
    }

    &__button,
    &__button_hover {
      left: 0;
      bottom: 0;
      width: 2.2rem;
      border-radius: 50%;
      position: absolute;
      transition: opacity .2s linear;
      box-shadow: rgba(33, 35, 38, 0.2) 0 10px 10px -10px;
    }

    &__button_hover {
      opacity: 0;
    }
  }

</style>
